<template>
  <div class="right-center">
    <div class="title right-center-title">果园文旅</div>
    <div class="digital-frame orchardBrigade">
      <div class="digital">
        <div>
          <span class="num font-size18 frame-text">{{travelOutput}}</span>
          <span class="unit font-size12">万元</span>
        </div>
        <div class="font-fam-CN font-size14">文旅年产值</div>
      </div>
      <div class="digital">
        <div>
          <span class="num font-size18 frame-text">{{receptionNum}}</span>
          <span class="unit font-size12">万人次</span>
        </div>
        <div class="font-fam-CN font-size14">年接待人数</div>
      </div>
    </div>
    <div class="cultural-brigade-title">文旅年度概况</div>
    <div id="cultural-brigade" ref="culturalEchart"></div>
  </div>
</template>
<script>
var echarts = require("echarts");
export default {
  data() {
    return {
      travelOutput: 200,
      receptionNum: 13,

      yearList: [2018, 2019, 2020],
      travelOutputList: [69, 91, 121],
      receptionNumList: [7, 10, 12]
    };
  },
  created() {
    window.addEventListener("resize", this.culturalEchart);
  },
  mounted() {
    this.getTravelInfo();
  },
  methods: {
    async getTravelInfo() {
      let res = await this.$axios.get("bigdata/index/getTravelSituationData");
      if (res.status === 200 && res.data.code === "1") {
        this.travelOutput = res.data.travelOutput;
        this.receptionNum = res.data.receptionNum;

        this.yearList = [];
        this.travelOutputList = [];
        this.receptionNumList = [];

        let _this = this;
        res.data.travelData.forEach(function(item) {
          _this.yearList.push(item.year);
          _this.travelOutputList.push(item.output);
          _this.receptionNumList.push(item.receptionNum);
        });

        this.culturalEchart();
      } else {
        this.culturalEchart();
      }
    },
    culturalEchart() {
      let myCharts = this.$echarts.init(this.$refs.culturalEchart);
      let yearData = this.yearList;
      let travelOutputData = this.travelOutputList;
      let receptionNumData = this.receptionNumList;

      myCharts.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },
        grid: {
          left: "6%",
          right: "6%",
          bottom: "10%",
          containLabel: true
        },
        legend: {
          data: ["年产值", "接待人数"],
          top: 20,
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 24,
          textStyle: {
            fontSize: 12, //字体大小
            color: "#FFFFFF" //字体颜色
          }
        },
        xAxis: [
          {
            type: "category",
            data: yearData,
            axisPointer: {
              type: "shadow"
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgba(255,255,255,0.5)"
              }
            },
            axisLine: {
              lineStyle: {
                color: "rgba(255,255,255,0.7)",
                width: 0.5
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "(万元)",
            min: 0,
            max: 160,
            interval: 40,
            splitNumber: 5,
            nameTextStyle: {
              color: "rgba(255,255,255,0.5)",
              fontSize: 12,
              padding: [0, 0, 0, -30]
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "rgba(255,255,255,0.5)"
              }
            },
            axisLine: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#092439"
              }
            }
          },
          {
            type: "value",
            name: "(万人次)",
            min: 0,
            max: 16,
            interval: 4,
            splitNumber: 5,
            nameTextStyle: {
              color: "rgba(255,255,255,0.5)",
              fontSize: 12,
              padding: [0, 0, 0, 7]
            },
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                color: "rgba(255,255,255,0.5)"
              }
            },
            axisLine: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "#092439"
              }
            }
          }
        ],
        series: [
          {
            name: "年产值",
            type: "bar",
            barWidth: 20,
            data: travelOutputData,
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#61FDE5" }, //柱图渐变色
                  { offset: 0.5, color: "#61FDE5" }, //柱图渐变色
                  { offset: 1, color: "#00EAFF" } //柱图渐变色
                ])
              }
            }
          },
          {
            name: "接待人数",
            type: "line",
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#E7DC61"
                }
              }
            },
            yAxisIndex: 1,
            data: receptionNumData
          }
        ]
      });
      window.addEventListener("resize", function() {
        myCharts.resize();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.right-center {
  width: 514px;
  height: 304px;
  background: url("../../../assets/bgIcon/garden.png") no-repeat;
  background-size: 100% 100%;
  margin: 12px 0;
  position: relative;
  padding-top: 25px;
  box-sizing: border-box;
  .right-center-title {
    position: absolute;
    top: -5px;
  }
  .digital-frame {
    display: flex;
    .digital {
      width: 110px;
      height: 60px;
      background: rgba(17, 35, 59, 1);
      border: 1px solid rgba(102, 204, 255, 0.4);
      box-shadow: 0px 0px 16px 4px rgba(0, 50, 49, 0.52);
      text-align: center;
    }
  }
  .orchardBrigade {
    padding-top: 18px;
    .digital {
      padding-top: 5px;
    }
  }
  .digital-frame .digital:first-child {
    margin: 0 60px 0 117px;
  }
  .cultural-brigade-title {
    position: absolute;
    top: 110px;
    left: 35px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(246, 246, 246, 1);
    line-height: 24px;
    background-image: -webkit-linear-gradient(top, #f6f6f6ff, #47abff99);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  #cultural-brigade {
    width: 100%;
    height: 200px;
  }
}
</style>
